/**
 * Wires up DT Contact options' "open chat widget" action buttons
 * (sections/dt-contact-options.liquid) to Gorgias's chat widget.
 *
 * Gorgias's chat widget renders into an iframe (id="chat-button") elsewhere on the page —
 * typically injected sitewide by the Gorgias app itself, not by this theme — and doesn't expose
 * a same-origin JS API for opening it from outside that iframe. The only way in is to reach into
 * the iframe and click its own open button. Cross-origin access failing is an expected, silent
 * no-op, not an error condition.
 */

function openGorgiasChat() {
  const iframe = document.getElementById('chat-button');
  if (!(iframe instanceof HTMLIFrameElement)) return;

  let iframeDocument;
  try {
    iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
  } catch {
    // Cross-origin — nothing more to do from here.
    return;
  }

  if (!iframeDocument) return;

  const deadline = Date.now() + 5000;
  const interval = setInterval(() => {
    const button = iframeDocument.querySelector('button');
    if (button) {
      button.click();
      clearInterval(interval);
    } else if (Date.now() > deadline) {
      clearInterval(interval);
    }
  }, 300);
}

document.addEventListener('click', (event) => {
  if (event.target.closest('.open-chat-box')) {
    openGorgiasChat();
  }
});
